<template>
	<div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		created:function(){
			document.title = '正在登录...';
		},
		methods:{
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/pages/mainPage.vue